import actions from 'store/actions'

import { default as interactivesTypes } from './types'

const fetchingActions = actions.createFetchingActions(interactivesTypes)
const updatingActions = actions.createUpdatingActions(interactivesTypes)
const updatingWithRetriesActions = actions.createUpdatingWithRetriesActions(
  interactivesTypes,
)

export default {
  ...fetchingActions,
  ...updatingActions,
  ...updatingWithRetriesActions,
}
